import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Save, ArrowLeft, ShieldCheck } from 'lucide-react';

const PrecautionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id || id === 'new';
  const session = JSON.parse(localStorage.getItem('user') || '{}');
  const [data, setData] = useState({ precautionnum: '', description: '', siteid: session.site_id || '' });

  useEffect(() => {
    if (!isNew) axios.get(`/api/precautions/${id}`).then(res => setData(res.data));
  }, [id, isNew]);

  const handleSave = async () => {
    try {
      await axios.post('/api/precautions/save', data);
      toast.success("Precaution Library Updated!");
      if (isNew) navigate(`/precautions/${data.precautionnum}`);
    } catch (err) { toast.error("Save failed"); }
  };

  return (
    <div className="flex flex-col h-screen bg-[#f3f4f6] text-[11px] font-sans uppercase font-bold tracking-tighter">
      <div className="bg-white p-2 border-b flex justify-between items-center shadow-sm z-20 font-black">
        <div className="flex gap-6 ml-4">
          <button onClick={() => navigate('/precautions')} className="p-1 hover:bg-gray-100 rounded-full text-blue-900"><ArrowLeft size={18} /></button>
          <HeaderField label="Num" value={data.precautionnum} isBold width="w-32" disabled={!isNew} onChange={v => setData({...data, precautionnum: v})} />
          <HeaderField label="Site" value={data.siteid} disabled width="w-24" />
        </div>
        <button onClick={handleSave} className="bg-[#3c70a4] text-white px-8 py-2 rounded mr-4 flex items-center gap-2 hover:bg-[#1a3353] shadow-lg">
           <Save size={14} /> SAVE TO LIBRARY
        </button>
      </div>
      <div className="flex-1 p-4 bg-[#f8f9fb]">
          <div className="max-w-4xl mx-auto">
            <SectionCard title="Precaution Definition">
               <div className="p-4 space-y-4">
                  <EditableField label="Precaution Code" value={data.precautionnum} disabled={!isNew} />
                  <div className="pt-2">
                    <label className="text-gray-400 font-black text-[8px] uppercase tracking-widest italic mb-1 block">Full Instruction Statement</label>
                    <textarea 
                        className="w-full p-3 border rounded outline-none font-black text-blue-900 bg-white" 
                        rows="4" value={data.description} 
                        onChange={e => setData({...data, description: e.target.value.toUpperCase()})}
                    />
                  </div>
               </div>
            </SectionCard>
          </div>
      </div>
    </div>
  );
};

const HeaderField = ({ label, value, onChange, width, isBold, disabled }) => (
  <div className="flex flex-col border-r px-4 last:border-0">
    <label className="text-[8px] text-gray-400 font-black uppercase tracking-widest mb-0.5 italic">{label}</label>
    <input className={`${width} border-b border-transparent outline-none py-0.5 font-black uppercase ${isBold ? 'text-blue-900 text-[12px]' : 'text-blue-700'} bg-transparent focus:border-blue-500`} 
           value={value || ''} disabled={disabled} onChange={e => onChange && onChange(e.target.value)} />
  </div>
);

const SectionCard = ({ title, children }) => (
  <div className="bg-white border rounded shadow-sm overflow-hidden transition-all hover:shadow-md">
    <div className="p-2 bg-slate-50 border-b font-black text-slate-500 uppercase text-[9px] tracking-widest flex items-center gap-2">
      <div className="w-1.5 h-3 bg-blue-800 rounded-full"></div> {title}
    </div>
    <div className="p-5">{children}</div>
  </div>
);

const EditableField = ({ label, value, onChange, onSearch, type = "text", disabled }) => (
  <div className="flex flex-col gap-1 border-b border-gray-200 group focus-within:border-blue-500 transition-all py-1">
    <label className="text-gray-400 font-black text-[8px] uppercase tracking-widest italic">{label}</label>
    <div className="flex items-center justify-between pb-0.5">
      <input type={type} disabled={disabled} className="outline-none font-black text-blue-900 bg-transparent w-full text-[11px]" 
        value={value || ''} onChange={e => onChange && onChange(e.target.value)} />
      {onSearch && <Search size={12} className="text-blue-400 cursor-pointer hover:text-blue-800" onClick={onSearch} />}
    </div>
  </div>
);

export default PrecautionDetails;
